//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.CombOptionsBuilder.js";
import "../no/ScCollector.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
let d=[[[0,"CalculationMethod",1,0],[1,"CombOptions",0,"GeometricUtilities.CombOptionsBuilder",0],[0,"DynamicProjection",1,0],[1,"FirstFaceSet",0,"ScCollector",0],[0,"NeedleDirection",1,0],[0,"ProjectionNormalFace",1,0],[0,"ProjectionOption",1,0],[0,"ProjectionXYZ",1,0],[0,"ScalingMethod",1,0],[1,"SecondFaceSet",0,"ScCollector",0],[0,"Vector",1,"Direction",0]],[[[],"UpdateWorkView",{},0,0]],[]];
SPLM.GeometricAnalysis.SurfaceIntersectionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.SurfaceIntersectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.SurfaceIntersectionBuilder.ProjectionTypes = Object.freeze({
    "None" : "None", "Normal" : "Normal", "Vector" : "Vector", "View" : "View", "Xyz" : "Xyz"});

SPLM.GeometricAnalysis.SurfaceIntersectionBuilder.XyzTypes = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z"});

SPLM.GeometricAnalysis.SurfaceIntersectionBuilder.NormalTypes = Object.freeze({
    "FaceSet1" : "FaceSet1", "FaceSet2" : "FaceSet2"});

SPLM.GeometricAnalysis.SurfaceIntersectionBuilder.LabelValues = Object.freeze({
    "Curvature" : "Curvature", "RadiusOfCurvature" : "RadiusOfCurvature"});

SPLM.GeometricAnalysis.SurfaceIntersectionBuilder.DirectionTypes = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside"});

SPLM.GeometricAnalysis.SurfaceIntersectionBuilder.CalculationTypes = Object.freeze({
    "Curvature" : "Curvature", "RadiusofCurvature" : "RadiusofCurvature"});

SPLM.GeometricAnalysis.SurfaceIntersectionBuilder.ScalingTypes = Object.freeze({
    "Linear" : "Linear", "Logarithmic" : "Logarithmic"});

export default SPLM;